var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"bg-light",attrs:{"colspan":_vm.row}},[_c('div',{staticClass:"bg-none"})])
}
var staticRenderFns = []

export { render, staticRenderFns }